/* Small header dropdowns (assets/header-dropdown.css).
   - Places each panel just below its menu title, centred. The panel is
     positioned by the header row, so its offsets are measured; the header is
     scaled with `zoom` at some widths, which currentCSSZoom accounts for.
   - On touch screens a tap on the title opens the panel instead of following
     the link (the first child repeats the title's page). */
(() => {
  const ITEM = '.menu-list__list-item--compact';
  const GAP = 10; // px between the title and the panel
  const EDGE = 12; // px the panel keeps from the window edges
  let lastPointerType = 'mouse';

  const place = (item) => {
    const link = item.querySelector('.menu-list__link');
    const panel = item.querySelector('.menu-list__submenu--compact');
    const host = panel && panel.offsetParent;
    if (!link || !host) return;
    const zoom = panel.currentCSSZoom || 1;
    const title = item.querySelector('.menu-list__link-title') || link;
    const linkBox = link.getBoundingClientRect();
    const titleBox = title.getBoundingClientRect();
    const hostBox = host.getBoundingClientRect();
    const centre = linkBox.left + linkBox.width / 2 - hostBox.left - host.clientLeft * zoom;
    const below = titleBox.bottom + GAP * zoom - hostBox.top - host.clientTop * zoom;
    // Keep the whole panel on screen, e.g. when the dropdown is the first menu item.
    const half = (panel.getBoundingClientRect().width || panel.offsetWidth * zoom) / 2;
    const minCentre = EDGE + half - hostBox.left;
    const maxCentre = document.documentElement.clientWidth - EDGE - half - hostBox.left;
    const clamped = Math.min(Math.max(centre, minCentre), Math.max(minCentre, maxCentre));
    panel.style.setProperty('--dropdown-left', `${clamped / zoom}px`);
    panel.style.setProperty('--dropdown-top', `${below / zoom}px`);
  };

  const closeAll = (except) => {
    document.querySelectorAll(`${ITEM}.is-open`).forEach((item) => {
      if (item !== except) item.classList.remove('is-open');
    });
  };

  document.addEventListener('pointerover', (event) => {
    const item = event.target instanceof Element && event.target.closest(ITEM);
    if (item) place(item);
  });

  document.addEventListener('focusin', (event) => {
    const item = event.target instanceof Element && event.target.closest(ITEM);
    if (item) place(item);
  });

  document.addEventListener('pointerdown', (event) => {
    lastPointerType = event.pointerType;
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const title = event.target.closest(`${ITEM} > .menu-list__link a`);
    const pointerType = event.pointerType || lastPointerType;

    if (title && pointerType && pointerType !== 'mouse') {
      event.preventDefault();
      const item = title.closest(ITEM);
      const opening = !item.classList.contains('is-open');
      closeAll(item);
      if (opening) place(item);
      item.classList.toggle('is-open', opening);
      return;
    }

    if (!event.target.closest(ITEM)) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
